import React from 'react';
import s from './StartPage.module.css';
import Header from './Header';
import HeroSection from './HeroSection';
import BeforeAfterSection from './BeforeAfterSection';
import ValuePropositionSection from './ValuePropositionSection';
import ConsistencySection from './ConsistencySection';
import TimelineSection from './TimelineSection';
import TestimonialsSection from './TestimonialsSection';
import CtaSection from './CtaSection';
import Footer from './Footer';
import ThreeSteps from './ThreeSteps';
import SimpleeCreateDifference from './SimpleeCreateDifference';
import VisualsAreEverything from './VisualsAreEverything';
import TimeComparison from './TimeComparison';
import DetailSectionPublic from '../pricing-page/DetailSectionPublic';

const StartPage: React.FC = () => {
    return (
        <div className={s.start_page}>
            <Header />
            <HeroSection />

            <ValuePropositionSection />
            <BeforeAfterSection />
            <ConsistencySection />
            <ThreeSteps />
            <SimpleeCreateDifference />
            <VisualsAreEverything />
            <TimeComparison />

            <TimelineSection />
            <TestimonialsSection />
            {/* <div id="pricing">
                <DetailSectionPublic />
            </div> */}
            <CtaSection />
            <Footer />
        </div>
    );
};

export default StartPage;
